import React, { useState } from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';
import './forgotPassword.css';
import { useDispatch, useSelector } from 'react-redux';
import { resetPasswordUser } from '../../rtk/thunks/authThunk';
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa6';

const ResetPassword = () => {
	const dispatch = useDispatch();
	const { loading, error, message } = useSelector((state) => state.auth);
	const [searchParams] = useSearchParams();
	const uid = searchParams.get('uid');
	const token = searchParams.get('token');

	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const [localError, setLocalError] = useState('');

	const formatError = (value) => {
		if (!value) return '';
		if (typeof value === 'string') return value;
		if (Array.isArray(value)) return value.filter(Boolean).join(' ');

		return value.detail || value.message || value.error || 'Password reset failed. The link may have expired.';
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLocalError('');

		if (password.length < 6) {
			setLocalError('Password must be at least 6 characters.');
			return;
		}
		if (password !== confirmPassword) {
			setLocalError('Passwords do not match.');
			return;
		}

		try {
			await dispatch(resetPasswordUser({ uidb64: uid, token, password })).unwrap();
		} catch (err) {
		}
	};

	if (!uid || !token) {
		return (
			<div className="forgot-password-page">
				<div className="forgot-password-card">
					<div className="forgot-password-header">
						<p className="forgot-password-eyebrow">Account recovery</p>
						<h2>Invalid reset link</h2>
						<p className="forgot-password-subtitle">
							This password reset link is missing or invalid. Please request a new one.
						</p>
					</div>
					<p className="forgot-password-link">
						Back to <NavLink to="/forgot-password">Forgot Password</NavLink>
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className="forgot-password-page">
			<div className="forgot-password-card">
				<div className="forgot-password-header">
					<p className="forgot-password-eyebrow">Account recovery</p>
					<h2>Reset your password</h2>
					<p className="forgot-password-subtitle">
						Choose a new password for your account.
					</p>
				</div>

				{message ? (
					<>
						<p className="form-success">{message}</p>
						<p className="forgot-password-link">
							<NavLink to="/sign-in">Continue to Sign In</NavLink>
						</p>
					</>
				) : (
					<form className="forgot-password-form" onSubmit={handleSubmit}>
						<div className="input-group">
							<input
								type={showPassword ? 'text' : 'password'}
								name="password"
								placeholder="New password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								required
							/>
							{showPassword ? (
								<FaEyeSlash className="password-icon" onClick={() => setShowPassword(false)} />
							) : (
								<FaEye className="password-icon" onClick={() => setShowPassword(true)} />
							)}
						</div>
						<div className="input-group">
							<input
								type={showPassword ? 'text' : 'password'}
								name="confirmPassword"
								placeholder="Confirm new password"
								value={confirmPassword}
								onChange={(e) => setConfirmPassword(e.target.value)}
								required
							/>
						</div>

						{localError && <p className="form-error">{localError}</p>}
						{error && <p className="form-error">{formatError(error)}</p>}

						<button type="submit" className="forgot-password-button" disabled={loading}>
							{loading ? 'Resetting...' : 'Reset password'}
						</button>

						<p className="forgot-password-link">
							Back to <NavLink to="/sign-in">Sign In</NavLink>
						</p>
					</form>
				)}
			</div>
		</div>
	);
};

export default ResetPassword;
